<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<!-- <style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style> -->
<style lang="scss">
@import "~common/scss/reset";
#app{
  height: 100%;
}
.offcn-loading{
  .el-loading-spinner{
    .el-icon-loading{
      font-size: 22px;
    }
    .el-icon-loading, .el-loading-text{
      color: #e60012;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue